import MenuIcon from '@atlaskit/icon/glyph/menu';
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import SideMenu from './SideMenu';
import { HamburgerMenu, SmallHeader } from './styles';

export default class SmallHeaderContent extends Component {
  static propTypes = {
    onClickLogin: PropTypes.func.isRequired,
    onClickLogout: PropTypes.func.isRequired,
    userData: ImmutablePropTypes.map.isRequired,
    userLoggedIn: PropTypes.bool.isRequired,
    username: PropTypes.string,
    userAvatarUrl: PropTypes.string,
  };

  state = {
    sideMenuIsOpen: false,
  };

  render() {
    return (
      <SmallHeader>
        <HamburgerMenu
          onClick={this.toggleMenu}
          // this is required by react-onclickoutside via
          // the MenuSectionsContainer element, do not remove
          className="sideMenuTrigger"
        >
          <MenuIcon label="Menu" size="large" />
        </HamburgerMenu>
        <SideMenu
          closeMenu={this.handleCloseMenu}
          onClickLogin={this.props.onClickLogin}
          onClickLogout={this.props.onClickLogout}
          showSmallHeaderMenu={this.state.sideMenuIsOpen}
          userData={this.props.userData}
          userLoggedIn={this.props.userLoggedIn}
          username={this.props.username}
          userAvatarUrl={this.props.userAvatarUrl}
          userEmail={this.props.userEmail}
        />
      </SmallHeader>
    );
  }

  handleCloseMenu = () => {
    this.setState({
      sideMenuIsOpen: false,
    });
  };

  toggleMenu = () => {
    this.setState(({ sideMenuIsOpen }) => ({ sideMenuIsOpen: !sideMenuIsOpen }));
  };
}
